import React from "react";
import "./BookCourseCard.css";

export default function BookCourseCard({ course, onApply }) {
  return (
    <div className="course-card-wrapper">
      {/* Visual Header */}
      <div className="course-card-image">
        <img src={course.image} alt={course.name} />
        <div className="course-card-gradient"></div>
        <div className="course-badge">DGCA Approved</div>
      </div>

      {/* Course Content Body */}
      <div className="course-card-content">
        <h3 className="course-card-title">{course.name}</h3>
        <p className="course-card-desc">{course.description}</p>

        {/* Training Meta Data Summary Row */}
        <div className="course-stats-row">
          <div className="course-stat-item">
            <span className="stat-label">Program Duration</span>
            <span className="stat-value">{course.days} Days</span>
          </div>

          <div className="course-stat-item">
            <span className="stat-label">Certification level</span>
            <span className="stat-value">DGCA Certified</span>
          </div>
        </div>

        {/* High-Impact CTA Row */}
        <div className="course-card-footer">
          <button
            className="course-apply-btn"
            onClick={(e) => {
              e.stopPropagation();
              onApply();
            }}
          >
            Start Your Journey
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}